import React from "react";
import { actionIconMap } from "./actionIcons";
import { TrackOccupation } from "@opstel/query/models/trackOccupation";
import { Action } from "@opstel/query/v2/models/action";

interface SBDActionIconProps {
  action: Action;
  occupation: TrackOccupation;
  color?: string;
}

export function SBDActionIcon({
  action,
  occupation,
  color,
}: SBDActionIconProps): React.JSX.Element | null {
  return actionIconMap[action.type]({ action, occupation, color });
}
